type Result<T, E = Error> = { data: T; error: null } | { data: null; error: E }

export async function tryCatchAsync<T, E = Error>(
  fn: () => Promise<T>,
): Promise<Result<T, E>> {
  try {
    return { data: await fn(), error: null } as const
  } catch (error) {
    return { data: null, error: error as E } as const
  }
}

export function tryCatch<T, E = Error>(
  fn: () => T,
): Result<T, E> {
  try {
    return { data: fn(), error: null } as const
  } catch (error) {
    return { data: null, error: error as E } as const
  }
}

